import Vue from "vue";
import VueRouter from "vue-router";
import mg from "../views/mg/mg.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "mg",
    component: mg,
    meta: {
      title: "芒果TV会员x省心会员" // 可以在这里设置自定义标题
    }
  },
   {
    path: "/site",
    name: "site",
    component: () =>
      import(/* webpackChunkName: "site" */ "../views/mg/site.vue"),
    meta: {
      title: "省心会员"
    }
  },
    {
    path: "/ms",
    name: "ms",
    component: () =>
      import(/* webpackChunkName: "ms" */ "../views/mg/ms.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
     {
    path: "/msv1",
    name: "msv1",
    component: () =>
      import(/* webpackChunkName: "msv1" */ "../views/mg/msv1.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
       {
    path: "/msv2",
    name: "msv2",
    component: () =>
      import(/* webpackChunkName: "msv1" */ "../views/mg/msv2.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
         {
    path: "/msv3",
    name: "msv3",
    component: () =>
      import(/* webpackChunkName: "msv1" */ "../views/mg/msv3.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
      {
    path: "/gdt",
    name: "gdt",
    component: () =>
      import(/* webpackChunkName: "gdt" */ "../views/mg/gdt.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
      {
    path: "/opcs",
    name: "opcs",
    component: () =>
      import(/* webpackChunkName: "mgv1" */ "../views/oppo/opcs.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
     {
    path: "/mgv1",
    name: "mgv1",
    component: () =>
      import(/* webpackChunkName: "mgv1" */ "../views/mg/mgv1.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
      {
    path: "/zn",
    name: "zn",
    component: () =>
      import(/* webpackChunkName: "zn" */ "../views/mg/zn.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
      {
    path: "/hz",
    name: "hz",
    component: () =>
      import(/* webpackChunkName: "mgv1" */ "../views/mg/hz.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
        {
    path: "/hzv1",
    name: "hzv1",
    component: () =>
      import(/* webpackChunkName: "mgv1" */ "../views/mg/hzv1.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
          {
    path: "/hzv2",
    name: "hzv2",
    component: () =>
      import(/* webpackChunkName: "hzv2" */ "../views/mg/hzv2.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
  
        {
    path: "/long",
    name: "long",
    component: () =>
      import(/* webpackChunkName: "mgv1" */ "../views/mg/long.vue"),
    meta: {
      title: "芒果TV会员x省心会员"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404.vue"),
    meta: {
      title: "404"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  base: '/mg',
  routes,
});

// 路由守卫：每次路由变化时设置页面标题
router.beforeEach((to, from, next) => {
  // 从路由的meta中获取标题，如果没有则使用路由的name
  document.title = to.meta.title || to.name || '芒果TV会员x省心会员';
  next();
});

export default router;